import { render, staticRenderFns } from "./historialPTI.vue?vue&type=template&id=fcd51492&scoped=true"
import script from "./historialPTI.vue?vue&type=script&lang=js"
export * from "./historialPTI.vue?vue&type=script&lang=js"
import style0 from "./historialPTI.vue?vue&type=style&index=0&id=fcd51492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd51492",
  null
  
)

export default component.exports